import {
	ChangeDetectionStrategy,
	Component,
	Output,
	EventEmitter,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { FireInsuranceBroker } from '@models/brokerage';
import { Store } from '@ngxs/store';
import {
	FireInsuranceBrokersDispatch,
	FireInsuranceBrokersSearchState,
} from '@state/algolia-search/fire-insurance-brokers-search';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

export enum DropdownSelect {
	SELECT_FIRE_INSURANCE_BROKER = 'SELECT_FIRE_INSURANCE_BROKER',
}

@Component({
	selector: 'app-search-fire-insurance-broker',
	templateUrl: './search-fire-insurance-broker.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SearchFireInsuranceBrokerComponent {
	public dropdownSelect = DropdownSelect;
	public ICON = ICON;
	public loading = false;
	public searchTerm: string;
	public selected;

	public fireInsuranceBrokers$ = this.store.select(
		FireInsuranceBrokersSearchState.getList,
	);
	public isSearching$ = this.store.select(
		FireInsuranceBrokersSearchState.getSearching,
	);
	public fireInsuranceBrokerage = this.store.selectSnapshot(
		SelectedMatter.fireInsuranceBrokerage,
	);

	@Output() onSelectedBroker = new EventEmitter<FireInsuranceBroker>();
	@Output() onCreateBroker = new EventEmitter<string>();

	constructor(
		private store: Store,
		private fireInsuranceBrokersDispatch: FireInsuranceBrokersDispatch,
	) {}

	public onSelect(ev: DropdownResult<FireInsuranceBroker>) {
		if (ev.group === 1) {
			const { result } = ev;
			this.onSelectedBroker.emit(result);
		}
	}

	public search = ($event) => {
		this.fireInsuranceBrokersDispatch.Search(
			$event,
			this.fireInsuranceBrokerage.id,
		);
		this.searchTerm = $event;
	};

	public createBroker = () => {
		this.onCreateBroker.emit(this.searchTerm);
	};
}
